import { createTheme, Theme } from "@mui/material";

let theme = createTheme({
    // Theme customization goes here as usual, including tonalOffset and/or
    // contrastThreshold as the augmentColor() function relies on these
    typography: {
        fontFamily: [
          'Raleway',
          'Open Sans',
          'Roboto',
          'sans-serif',
        ].join(','),
      },
});


const MAIN_COLORS = {
    primary: "#9ab878",
    "twa-green": "#9ab878",
    secondary: "#284651",
    "twa-blue": "#284651",
    "twa-live": "#717c96",
    "twa-grey": "#F5F6FB",
    "twa-black": "#000000",
};

declare module '@mui/material/styles' {
    interface Palette {
        "twa-green": Palette['primary'];
        "twa-blue": Palette['primary'];
        "twa-live": Palette['primary'];
        "twa-grey": Palette['primary'];
        "twa-black": Palette['primary'];
    }

    interface PaletteOptions {
        "twa-green"?: PaletteOptions['primary'];
        "twa-blue"?: PaletteOptions['primary'];
        "twa-live"?: PaletteOptions['primary'];
        "twa-grey"?: PaletteOptions['primary'];
        "twa-black"?: PaletteOptions['primary'];
    }
}

const augmentPalette = (theme: Theme) => {
    return Object.entries(MAIN_COLORS).reduce((acc, entry) => {
        acc[entry[0]] = theme.palette.augmentColor({
            color: {
                main: entry[1],
            },
            name: entry[0],
        }
        );
        return acc;
    }, {} as any);
}

theme = createTheme(theme, {
    palette: augmentPalette(theme),
});

export default theme;